import { string, object } from "yup";

const createUserSchema = object().shape({
  name: string().required("必須填寫姓名"),
  idNumber: string().required("必須填寫身份證字號"),
});

export { createUserSchema };
